import React, { useEffect } from "react";
import CommonLayout from "../layout/CommonLayout";
import BackClick from "../components/BackClick";
import CommonButton from "../components/CommonButton";
import failedicon from "../assets/images/icons/failedicon.svg";
import { useNavigate, useParams } from "react-router-dom";
import { getDomainInfo } from "../utils/utils";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const { hostname, isPredefinedDomain, uid } = getDomainInfo(userId);
  const handleClick = () => {
    navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
  };
  return (
    <CommonLayout>
      <BackClick />
      <div
        style={{
          marginTop: "50px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "18px",
        }}
      >
        <div style={{ height: "70px", width: "70px" }}>
          <img height={"70px"} width={"70px"} src={failedicon} alt="" />
        </div>
        <h2>Payment Failed</h2>

        <CommonButton name={"Try Again"} width={"80%"} onClick={handleClick} />
      </div>
    </CommonLayout>
  );
};

export default PaymentFailed;
